var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.subFormAvailable
    ? _c(
        "div",
        [
          _c(
            "b-row",
            { staticClass: "d-flex align-items-center" },
            [
              _c("h2", [_vm._v("\n            Fahrzeug\n        ")]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "klippa-subform-toggle-btn",
                  attrs: { variant: "primary" },
                  on: { click: _vm.toggleAll },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.someIncluded ? "Alle abwählen" : "Alle auswählen"
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldVin",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "VIN",
                          property: "vin",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldLicensePlate",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Kennzeichen",
                          property: "licensePlate",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldModel",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Modell",
                          property: "model",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldHsn",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "HSN",
                          property: "hsn",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldTsn",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "TSN",
                          property: "tsn",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "text",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldMileage",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Kilometerstand",
                          property: "mileage",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "number",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-klippa-info-card-element", {
                        ref: "fieldRegistrationDate",
                        staticClass: "col-12",
                        attrs: {
                          "form-context": _vm.formContext,
                          label: "Erstzulassung",
                          property: "registrationDate",
                          "subform-identifier": _vm.subformIdentifier,
                          type: "datepicker",
                        },
                        on: {
                          "field-hover-changed": (data) => {
                            _vm.$emit("field-hover-changed", data)
                          },
                          "field-inclusion-changed":
                            _vm.onFieldInclusionChangedWithTracking,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }